import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de44639a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "visitRecord" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "回访记录", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "日期", -1))
const _hoisted_8 = { class: "tdBox" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 新建 ")
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 3,
  class: "table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "回访记录", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "日期", -1))
const _hoisted_16 = { class: "tdBox" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 新建 ")

import { onMounted, ref, Ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { getVisitRecordList } from "../../config/interface";
// 定义状态

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter(); // 创建路由
const route = useRoute();
let coId = ref("");
// const dialogVisible = ref<Boolean>(false); // 控制对话框显示状态
const dialogVisible: Ref<Boolean> = ref(false);
let back = "<";
// 接口返回数据
const returnInfo = ref({});
// 临时存放回访信息
const visitInfo = ref({});

// 定义方法
const handleBack = () => {
  router.back();
};
// 点击详情按钮，显示详情对话框
const goDetail = (item: any) => {
	console.log(item);
	let params = {
		createTime: item.createTime.slice(0,10),
		visitRecord: item.visitRecord
	}
  visitInfo.value = {};
  visitInfo.value = params;
  dialogVisible.value = true;
};
// 点击创建按钮，携带学生id，前往回访记录创建页面
const handleCreate = () => {
  router.push({
    path: "/message/create",
    query: { coId:coId.value,type:1 },
  });
};
// 点击创建按钮，携带研究生id，前往回访记录创建页面
const handleCreate2 = () => {
  router.push({
    path: "/message/create",
    query: { coId:coId.value,type:2 },
  });
};

// 使用钩子
onMounted(() => {
  let params = {
    coId: route.query.coId,
    pageNum: 1,
  };
	coId.value = route.query.coId as string;
  getVisitRecordList(params).then((res) => {
    console.log(res);
    returnInfo.value = res.data.data;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back",
        onClick: handleBack
      }, _toDisplayString(_unref(back)) + " 返回", 1)
    ]),
    (returnInfo.value.stuRecord)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "学生回访记录"))
      : _createCommentVNode("", true),
    (returnInfo.value.stuRecord)
      ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.stuRecord, (item, index) => {
              return (_openBlock(), _createElementBlock("td", { key: index }, " 回访记录" + _toDisplayString(index + 1), 1))
            }), 128)),
            _hoisted_6
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.stuRecord, (item, index) => {
              return (_openBlock(), _createElementBlock("td", { key: index }, [
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(item.createTime.slice(0, 10)) + " ", 1),
                  _createElementVNode("div", {
                    class: "check",
                    onClick: ($event: any) => (goDetail(item))
                  }, "查看", 8, _hoisted_9)
                ])
              ]))
            }), 128)),
            _createElementVNode("td", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleCreate
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (returnInfo.value.posRecord)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_11, "研究生回访记录"))
      : _createCommentVNode("", true),
    (returnInfo.value.posRecord)
      ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
          _createElementVNode("tr", null, [
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.posRecord, (item, index) => {
              return (_openBlock(), _createElementBlock("td", { key: index }, " 回访记录" + _toDisplayString(index + 1), 1))
            }), 128)),
            _hoisted_14
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnInfo.value.posRecord, (item, index) => {
              return (_openBlock(), _createElementBlock("td", { key: index }, [
                _createElementVNode("div", _hoisted_16, [
                  _createTextVNode(_toDisplayString(item.createTime.slice(0, 10)) + " ", 1),
                  _createElementVNode("div", {
                    class: "check",
                    onClick: ($event: any) => (goDetail(item))
                  }, "查看", 8, _hoisted_17)
                ])
              ]))
            }), 128)),
            _createElementVNode("td", null, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: handleCreate2
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      title: "回访记录",
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: visitInfo.value,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "回访日期",
              prop: "createTime",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: visitInfo.value.createTime,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visitInfo.value.createTime) = $event)),
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "回访记录",
              prop: "visitRecord",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: visitInfo.value.visitRecord,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visitInfo.value.visitRecord) = $event)),
                  type: "textarea",
                  autosize: "",
                  style: {"width":"350px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})